import { Component, EventEmitter, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

// ---------Shared--------------------------------------------
import { LoginService } from '../../shared-modules/login/login.service';
import { UserService } from '../../shared-components/user/user.service';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { StudentService } from '../../shared-components/student/student.service';
import { YearService } from '../../shared-components/year/year.service';
import { LoginSettings } from '../../shared-modules/login/loginSetting.model';
import { UserSchoolYearPolicies } from '../../shared-components/user/user-school-year-policies.model';
import { User } from '../../shared-components/user/user.model';
import { Student } from '../../shared-components/student/student.model';
import { CourseSchedule } from '../../shared-components/student/course-schedule.model';
import { GradesService } from './grades.service';
import { ReportCardGradesTerm, GradesPreferences, CategoryAverage, GradesBehaviorSocialSkills } from './grades.model';
import { TraditionalGradesComponent } from './traditional-grades/traditional-grades.component';
import { StandardsBasedGradesComponent } from './standards-based-grades/standards-based-grades.component';
import { CodeLegendComponent } from './code-legend/code-legend.component';
import { Student360Service } from '../student360.service';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { GradeOverrideLegendComponent } from '../../shared-components/controls/grade-override-legend/grade-override-legend.component';
import { SchoolYearSettings } from '../../shared-components/year/school-year-settings.model';

@AutoUnsubscribe()
@Component({
    selector: 'app-grades',
    templateUrl: './grades.component.html',
    styles: []
})
export class GradesComponent implements OnInit, OnDestroy {

    // -----------Grid functionality---------------------------------
    selectionIndex = 0;
    // ------------Element references--------------------------------
    @ViewChild(TraditionalGradesComponent) traditionalGradesComponent: TraditionalGradesComponent;
    @ViewChild(StandardsBasedGradesComponent) standardsBasedGradesComponent: StandardsBasedGradesComponent;

    // ------------Selection/Flags-----------------------------------
    expandEmitter: boolean;
    allowMultiSelect = true;
    selections: boolean[] = [];
    showGradesMessage = false;

    // ------------------------------------------------------------
    LoginSettings: LoginSettings;
    userSchoolYearPolicies: UserSchoolYearPolicies;
    currentUser: User;
    selectedStudent: Student;
    student360YearSubscription: Subscription;
    selectedStudentSubscription: Subscription;
    studentEnrollment = this.studentService.studentEnrollment;
    gradesPreferences: GradesPreferences;
    studentSchedules: CourseSchedule[] = [];
    reportCardGradesTerm: ReportCardGradesTerm[] = [];
    reportCardStandardGradesTerm: ReportCardGradesTerm[] = [];
    studentTerms: ReportCardGradesTerm[] = [];
    studentTermsStandardTab: ReportCardGradesTerm[] = [];
    categoryAverages: CategoryAverage[] = [];
    gradesBehaviorSocialSkills: GradesBehaviorSocialSkills[] = [];
    initialSelection = [];
    legendDialogRef: MatDialogRef<CodeLegendComponent>;
    overrideLegendDialogRef: MatDialogRef<GradeOverrideLegendComponent>;
    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    selection = new SelectionModel<any>(this.allowMultiSelect, this.initialSelection);
    tabNames: string[] = [];
    parentPortalSubscription: Subscription;
    staffAssignedPortalsSubscription: Subscription;
    schoolYearSettings: SchoolYearSettings[] = [];
    // ------------Selection/Flags-----------------------------------
    gradesMessage = '';
    showProgressGrades = false;
    isProgressGrades = false;
    showAssignmentLink = false;
    showAttendanceLink = false;
    showSendEmailLink = false;
    isBusy = true;
    isDualEnrollment = false;
    constructor(
        private loginService: LoginService,
        private userService: UserService,
        private userPreferencesService: UserPreferencesService,
        private studentService: StudentService,
        private yearService: YearService,
        private gradesService: GradesService,
        private dialog: MatDialog,
        private parentPortalService: Student360Service,
        private classroom360Service: Classroom360Service
    ) {
        this.selectedStudentSubscription = studentService.selectedStudentStream$.subscribe(
            studentId => {
                if (studentId > 0) {
                    if (this.studentService.StandradTabByCurrentGrade == true) {
                        this.selectionIndex = this.studentService.selectionIndex;
                    }
                    this.loadStudentInfo(studentId);
                }
            });

        this.student360YearSubscription = this.yearService.observableStudent360YearStream$.subscribe(() => {
            this.loadStudentInfo(this.studentService.selectedStudent.Id);
        });

        if (this.userService.userType == 1) {
            this.staffAssignedPortalsSubscription = this.classroom360Service.observableStaffAssignedPortalsStream$.subscribe(_ => {
                this.getPortalInfo();
            });
        }
        else {
            this.parentPortalSubscription = this.parentPortalService.observableParentAssignedPortalsStream$.subscribe(_ => {
                this.getPortalInfo();
            });
        }
        this.getPortalInfo();
    }

    ngOnInit() {
        this.showSendEmailLink = true;
        this.LoginSettings = this.loginService.LoginSettings;
        if (this.studentService.StandradTabByCurrentGrade == true) {
            this.selectionIndex = this.studentService.selectionIndex;
        }
        this.loadStudentInfo(this.studentService.selectedStudent.Id);
        this.getPortalInfo();
    }

    ngOnDestroy() {
        this.studentService.StandradTabByCurrentGrade = false;
        this.studentService.selectionIndex = 0;
        // V9 ONE-6156
        if (!this.loginService.LoginSettings.V10) {
            this.studentService.selectedCardCourse = null;
        }
        this.student360YearSubscription.unsubscribe();
        this.selectedStudentSubscription.unsubscribe();
    }

    getPortalInfo() {
        if (this.userService.userType == 1) {
            if (this.classroom360Service.staffAssignedPortals.filter(x => x.PortalName == 'Attendance' && x.Disabled == false && x.ParentModule != '/classroom360') != null
                && this.classroom360Service.staffAssignedPortals.filter(x => x.PortalName == 'Attendance' && x.Disabled == false && x.ParentModule != '/classroom360').length > 0) {
                this.showAttendanceLink = true;
            }
            if (this.classroom360Service.staffAssignedPortals.filter(x => x.PortalName == 'Assignments' && x.Disabled == false && x.ParentModule != '/classroom360') != null
                && this.classroom360Service.staffAssignedPortals.filter(x => x.PortalName == 'Assignments' && x.Disabled == false && x.ParentModule != '/classroom360').length > 0) {
                this.showAssignmentLink = true;
            }
        }
        else {
            if (this.parentPortalService.parentAssignedPortals.filter(x => x.PortalName == 'Attendance' && x.Disabled == false) != null
                && this.parentPortalService.parentAssignedPortals.filter(x => x.PortalName == 'Attendance' && x.Disabled == false).length > 0) {
                this.showAttendanceLink = true;
            }
            if (this.parentPortalService.parentAssignedPortals.filter(x => x.PortalName == 'Assignments' && x.Disabled == false) != null
                && this.parentPortalService.parentAssignedPortals.filter(x => x.PortalName == 'Assignments' && x.Disabled == false).length > 0) {
                this.showAssignmentLink = true;
            }
        }
    }

    loadStudentInfo(studentId: number) {
        this.clearStudentData();
        this.selectedStudent = this.studentService.students.filter(function (student) { return student.Id == studentId; })[0];
        this.studentEnrollment = this.studentService.studentEnrollment;
        if (this.studentEnrollment != undefined) {
            if (this.LoginSettings != null) {
                if (this.LoginSettings.V10 == true) {
                    this.getGradesMessage();
                }
                else {
                    this.getReportCardTerms();
                }
            }
        }
    }

    clearStudentData() {
        this.studentSchedules = [];
        this.reportCardGradesTerm = [];
        this.reportCardStandardGradesTerm = [];
        this.studentTerms = [];
        this.studentTermsStandardTab = [];
        this.categoryAverages = [];
        this.studentService.StandradTabByCurrentGrade = false;
        this.studentService.selectionIndex = 0;
    }

    getGradesMessage() {
        if (this.LoginSettings.V10) {
            this.userService.getUserSchoolYearPolicies(this.studentEnrollment.SiteYearId, this.studentEnrollment.SchoolId).subscribe(data => {
                this.userSchoolYearPolicies = data;
                if (this.userSchoolYearPolicies.ShowMessageOnS360GradesPage == true) {
                    this.gradesMessage = this.userSchoolYearPolicies.S360GradesMessage;
                }

                this.getReportCardTerms();
            });
        }
    }

    getReportCardTerms() {
        if (this.reportCardGradesTerm.length == 0 && this.studentEnrollment.SiteYearId != undefined) {
            this.gradesService.getReportCardTerms(this.studentEnrollment.SiteYearId, true, false).subscribe(data => {
                this.reportCardGradesTerm = data;
                this.getReportCardTermsStandardTab();
            });
        }
        else {
            this.getUserPreferences();
        }
    }

    getReportCardTermsStandardTab() {
        if (this.reportCardStandardGradesTerm.length == 0 && this.studentEnrollment.SiteYearId != undefined) {
            this.gradesService.getReportCardTerms(this.studentEnrollment.SiteYearId, true, true).subscribe(data => {
                this.reportCardStandardGradesTerm = data;
                this.getUserPreferences();
            });
        }
    }

    getReportCardTermsBySiteYear(siteYearId: number, schoolName: string) {
        if (siteYearId != undefined && siteYearId > 0) {
            this.gradesService.getReportCardTerms(siteYearId, true, true).subscribe(data => {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].GradingTerm.indexOf('P') >= 0) {
                        this.showProgressGrades = true;
                    }
                }
                data.forEach(function (term: ReportCardGradesTerm) {
                    term.SchoolName = schoolName;
                    if (this.studentTerms.filter(function (ele) { return ele.TermDefinitionId == term.TermDefinitionId && ele.GradingTerm == term.GradingTerm; })[0] == null) {
                        this.studentTerms.push(term);
                        this.isDualEnrollment = true;
                    }
                    if (this.studentTermsStandardTab.filter(function (ele) { return ele.TermDefinitionId == term.TermDefinitionId && ele.GradingTerm == term.GradingTerm; })[0] == null) {
                        this.studentTermsStandardTab.push(term);
                    }
                }.bind(this));

                this.setTabDetails();
            });
        }
    }

    getUserPreferences() {
        if (this.LoginSettings.V10 == false) {
            if (this.gradesPreferences == null || this.gradesPreferences.ShowProgressGrades == undefined) {
                this.userPreferencesService.getUserPreferences(this.selectedStudent.Id, '/OneSISGradesPreferences', 0, '', false).subscribe(data => {
                    this.gradesPreferences = JSON.parse(data[0]);
                    for (let i = 0; i < this.reportCardGradesTerm.length; i++) {
                        if (this.reportCardGradesTerm[i].GradingTerm.indexOf('P') >= 0) {
                            this.showProgressGrades = true;
                        }
                    }
                    if (this.showProgressGrades == true && this.gradesPreferences.ShowProgressGrades == true) {
                        this.isProgressGrades = true;
                    }

                    this.getTerms();
                });
            }
            else {
                for (let i = 0; i < this.reportCardGradesTerm.length; i++) {
                    if (this.reportCardGradesTerm[i].GradingTerm.indexOf('P') >= 0) {
                        this.showProgressGrades = true;
                    }
                }
                if (this.showProgressGrades == true && this.gradesPreferences.ShowProgressGrades == true) {
                    this.isProgressGrades = true;
                }

                this.getTerms();
            }
        }
        else {
            this.getTerms();
        }
    }

    saveUserPreferences() {
        const xmlStream: string[] = [];
        this.gradesPreferences.ShowProgressGrades = this.isProgressGrades;
        xmlStream.push(JSON.stringify(this.gradesPreferences));

        this.userPreferencesService.saveUserPreferences(this.selectedStudent.Id, '/OneSISGradesPreferences', xmlStream, 0, '', false).subscribe();
    }

    getTerms() {
        this.studentTerms = [];
        this.studentTermsStandardTab = [];
        if (this.LoginSettings.V10 == false && this.isProgressGrades == false) {
            this.reportCardGradesTerm.forEach(function (term: ReportCardGradesTerm) {
                if (term.GradingTerm.indexOf('P') < 0) {
                    this.studentTerms.push(term);
                }
                else {
                    this.showProgressGrades = true;
                }
            }.bind(this));

            this.reportCardStandardGradesTerm.forEach(function (term: ReportCardGradesTerm) {
                if (term.GradingTerm.indexOf('P') < 0) {
                    this.studentTermsStandardTab.push(term);
                }
                else {
                    this.showProgressGrades = true;
                }
            }.bind(this));
        }
        else {
            if (this.isProgressGrades == true) {
                this.showProgressGrades = true;
            }
            this.studentTerms = this.reportCardGradesTerm;
            this.studentTermsStandardTab = this.reportCardStandardGradesTerm;
        }

        if (this.LoginSettings.V10 == true && this.userSchoolYearPolicies != null) {
            if (this.userSchoolYearPolicies.S360GradesDisplayFinalScoreGrade == true) {
                const finalTerm = new ReportCardGradesTerm();
                finalTerm.GradingTerm = 'Final';
                finalTerm.GradingTermDescription = 'Final';
                finalTerm.V10Flag = true;
                this.studentTerms.push(finalTerm);
            }
        }

        if (this.LoginSettings.V10 == true) {
            this.studentTermsStandardTab = this.studentTerms;
        }

        this.getStudentSchedule();
    }

    getStudentSchedule() {
        const siteYearId: number = this.studentEnrollment.SiteYearId;
        this.studentService.getStudentSchedule(this.selectedStudent.Id, this.yearService.student360Year.Id, 3, false, true, this.isProgressGrades, this.userService.userId, false, false, true, true).subscribe(data => {
            this.studentSchedules = data;
            if (this.studentSchedules.length == 0) {
                this.isBusy = false;
                if (this.selectionIndex == 0) {
                    this.traditionalGradesComponent.traditionalGrades = [];
                }
                else if (this.selectionIndex == 1) {
                    this.standardsBasedGradesComponent.standardBasedGrades = [];
                }
                this.tabNames = [];
                this.clearStudentData();
            }
            else {
                if (this.studentSchedules.filter(function (ele) { return ele.SiteYearId == siteYearId; }).length > 0) {
                    const schoolName: string = this.studentSchedules.filter(function (ele) { return ele.SiteYearId == siteYearId; })[0].SchoolName;
                    for (let j = 0; j < this.studentTerms.length; j++) {
                        if (this.studentTerms[j].SchoolName == null) {
                            this.studentTerms[j].SchoolName = schoolName;
                        }
                    }

                    for (let k = 0; k < this.studentTermsStandardTab.length; k++) {
                        if (this.studentTermsStandardTab[k].SchoolName == null) {
                            this.studentTermsStandardTab[k].SchoolName = schoolName;
                        }
                    }
                }
                if (this.LoginSettings.V10 == false) {
                    const siteYears: any[] = [];
                    for (let i = 0; i < this.studentSchedules.length; i++) {
                        if (siteYears.filter(o => o.SiteYearId == this.studentSchedules[i].SiteYearId).length == 0) {
                            const siteYear = {
                                SchoolId: this.studentSchedules[i].SchoolId,
                                SiteYearId: this.studentSchedules[i].SiteYearId,
                                SchoolName: this.studentSchedules[i].SchoolName
                            };
                            siteYears.push(siteYear);
                        }
                    }

                    if (siteYears.length > 0) {
                        const yearId = this.yearService.student360Year.Id != undefined && this.yearService.student360Year.Id != null ? this.yearService.student360Year.Id : this.yearService.defaultYear.Id;
                        siteYears.forEach(function (siteYear: any) {
                            this.getSchoolYearSettings(yearId, siteYear.SchoolId);
                            this.getReportCardBehaviorSocialSkills(siteYear.SiteYearId, siteYear.SchoolName);
                            this.getReportCardTermsBySiteYear(siteYear.SiteYearId, siteYear.SchoolName);
                        }.bind(this));
                    }
                    else {
                        this.setTabDetails();
                    }
                }
                else {
                    if (this.studentSchedules.length > 0 && this.studentSchedules[0].ReportCardGradesTerms.filter(t => t.DisplayCategoryScores).length > 0) {
                        this.gradesService.getStudentCategoryAverage(this.selectedStudent.Id, this.yearService.student360Year.Id).subscribe(avg => {
                            for (const course of this.studentSchedules) {
                                const averages = avg.filter(a => a.SSEC_ID == course.Id);
                                const categoryTerms = [];
                                const categories = [];
                                for (const average of averages) {
                                    if (categoryTerms.filter(t => t.Id == average.TermId).length == 0) {
                                        categoryTerms.push({ Id: average.TermId, Name: average.TermName });
                                    }
                                    if (categories.filter(c => c.Name == average.CategoryName).length == 0) {
                                        categories.push({ Name: average.CategoryName, Weight: average.CategoryWeight });
                                    }
                                }
                                course.CategoryAverages = averages;
                                course.CategoriesTerms = { terms: categoryTerms, categories: categories };
                            }
                        });
                    }
                    this.setTabDetails();
                }

                // Add Terms for Alternate Enrollment
                if (this.LoginSettings.V10 && this.studentSchedules.filter(s => s.SiteYearId != siteYearId).length > 0) {
                    const alternateYearId = this.studentSchedules.filter(s => s.SiteYearId != siteYearId)[0].SiteYearId;
                    const alternateSchoolName = this.studentSchedules.filter(s => s.SiteYearId == alternateYearId)[0].SchoolName;
                    this.gradesService.getReportCardTerms(alternateYearId, true, false).subscribe(terms => {
                        for (const term of terms) {
                            if (term.SchoolName == null) {
                                term.SchoolName = alternateSchoolName;
                            }
                        }
                        this.reportCardGradesTerm.push.apply(this.reportCardGradesTerm, terms);
                        // this.studentTerms.push.apply(this.studentTerms, terms);
                        this.traditionalGradesComponent.getTraditionalGrades();
                    });
                }

                setTimeout(() => {
                    if (this.selectionIndex == 0) {
                        this.traditionalGradesComponent.getTraditionalGrades();
                    }
                    else if (this.selectionIndex == 1) {
                        this.standardsBasedGradesComponent.getStandardBasedGrades();
                        // V9 ONE-6156
                        if (this.studentService.selectedCardCourse) {
                            if (!this.loginService.LoginSettings.V10) {
                                if (this.standardsBasedGradesComponent.standardBasedGrades.length > 0) {
                                    const row = this.studentSchedules.find(x => (x.SubjectCode + '-' + x.Section).toString().trim().toLowerCase() == this.studentService.selectedCardCourse.CourseNumber.toString().trim().toLowerCase());
                                    this.standardsBasedGradesComponent.toggleExpanded(row);
                                    this.studentService.selectedCardCourse = null;
                                }
                            }
                        }
                    }
                });
            }
        });
    }

    getSchoolYearSettings(yearId: number, schoolId: number) {
        this.yearService.getSchoolYearSettings(yearId, schoolId).subscribe(data => {
            this.schoolYearSettings.push(data);
        });
    }

    setTabDetails() {
        this.tabNames = [];
        if (this.studentSchedules.filter(o => o.ShowTraditionalTab == true).length > 0) {
            this.tabNames.push('TRADITIONAL');
        }
        if (this.studentSchedules.filter(o => o.ShowStandardTab == true).length > 0) {
            this.tabNames.push('STANDARDS-BASED');
            if (this.tabNames.length == 1) {
                this.selectionIndex = 1;
            }
        }
        else {
            this.selectionIndex = 0;
        }

        setTimeout(() => {
            if (this.isDualEnrollment == true) {
                if (this.selectionIndex == 0) {
                    this.traditionalGradesComponent.getTraditionalGrades();
                }
                else if (this.selectionIndex == 1) {
                    this.standardsBasedGradesComponent.getStandardBasedGrades();
                }
            }
        }, 100);
    }

    viewProgressGrades() {
        if (this.LoginSettings.V10 == true) {
        }
        else {
            this.saveUserPreferences();
            this.getReportCardTerms();
        }
    }

    getReportCardBehaviorSocialSkills(siteYearId: number, schoolName: string) {
        if (this.LoginSettings.V10 == false) {
            this.gradesService.getReportCardBehaviorSocialSkillDescription(siteYearId).subscribe(result => {
                this.gradesBehaviorSocialSkills.push({
                    SiteYearId: siteYearId,
                    SchoolName: schoolName,
                    behaviorSocialSkillDescription: result
                });
            });
        }
    }

    selectionChange(selectionIndex: number) {
        this.selectionIndex = selectionIndex;
    }

    expandAll(expand: boolean) {
        if (this.selectionIndex == 0) {
            this.traditionalGradesComponent.expandAll(expand);
        }
        else if (this.selectionIndex == 1) {
            this.standardsBasedGradesComponent.expandAll(expand);
        }
    }

    // ------------Modal window-----------------------
    legendClick() {
        this.legendDialogRef = this.dialog.open(CodeLegendComponent, { panelClass: 'tyl-mat-dialog', maxWidth: '550px' });
        const standardCourse = this.studentSchedules.filter(s => s.ShowStandardTab)[0];
        this.legendDialogRef.componentInstance.courseId = (standardCourse != undefined) ? standardCourse.Id : 0;
    }

    overrideLegendClick() {
        this.overrideLegendDialogRef = this.dialog.open(GradeOverrideLegendComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
    }
}
